function UploadFileController () {
  var ctrl = this

  function formatSize (bytes) {
    var kb = bytes / 1024
    var mb = kb / 1024
    var gb = mb / 1024

    if (gb >= 1) {
      return Number.parseInt(gb) + 'GB'
    }
    if (mb >= 1) {
      return Number.parseInt(mb) + 'MB'
    }
    if (kb >= 1) {
      return Number.parseInt(kb) + 'KB'
    }
    return Number.parseInt(bytes) + 'B'
  }

  ctrl.reduceName = function (name) {
    var maxLength = 25
    if (name.length > maxLength) {
      return name.substring(0, maxLength - 3) + '...'
    }
    return name
  }

  ctrl.$onInit = ctrl.$onChanges = function () {
    this.file.formattedSize = formatSize(this.file.size)
    this.file.title = this.file.name.substring(0, this.file.name.lastIndexOf('.'))
    this.file.extension = this.file.type.substring(this.file.type.search(/\//) + 1)
  }
}

export { UploadFileController }
